const BRAND = 'MerchantFloor';

// Page titles are edited in admin and often leave the brand out. Search engines and
// LLMs tie a page to the brand through its title, so add it unless it's already there.
export function withBrand(title: string): string {
  const trimmed = title.trim();
  if (!trimmed) return BRAND;
  if (/merchant\s?floor/i.test(trimmed)) return trimmed;
  return `${trimmed} | ${BRAND}`;
}
